import { motion } from 'framer-motion';
import { Zap, Cog, Settings, Wrench, Cpu, MoreHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProductsSection = () => {
  const products = [
    {
      title: 'الکترو موتور های کره گیر',
      description: 'الکترو موتورهای جریان متناوب با کیفیت بالا برای صنایع مختلف',
      icon: Zap,
      link: "/products"
    },
    {
      title: 'الکترو موتور های نوفراست',
      description: 'الکترو موتورهای جریان مستقیم با راندمان عالی',
      icon: Cog,
       link: "/products"
    },
    {
      title: 'الکترو موتور های درب بازکن',
      description: 'خدمات تخصصی سیم‌پیچی و بازسازی آرمیچر',
      icon: Settings,
       link: "/products"
    },
    {
      title: 'الکترو موتور های ساکشن',
      description: 'الکترو موتورهای پله‌ای دقیق برای کاربردهای اتوماسیون',
      icon: Wrench,
       link: "/products"
    },
    {
      title: 'الکترو موتور های کالباس بر',
      description: 'سیستم‌های کنترل و درایو الکترو موتورهای الکتریکی',
      icon: Cpu,
       link: "/products"
    },
    {
      title: 'الکترو موتور های کولر آبی',
      description: 'مشاهده کلیه محصولات و خدمات شرکت',
      icon: MoreHorizontal,
       link: "/products"
    },
    {
      title: 'الکترو موتور های هود',
      description: 'مشاهده کلیه محصولات و خدمات شرکت',
      icon: MoreHorizontal,
       link: "/products"
    },
  ];
  const categoryIds = [6, 7, 8, 9, 10, 11, 1];

  return (
    <section id="products" className="py-20 bg-steel-light/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            محصولات ما
          </h2>
          <p className="text-steel dark:text-slate-300 text-lg max-w-2xl mx-auto">
            طیف گسترده‌ای از الکترو موتورهای الکتریکی و خدمات تخصصی برای نیازهای متنوع صنعتی
          </p>
        </motion.div>

        <div className="grid auto-rows-fr grid-cols-1 items-stretch gap-6 md:grid-cols-2 lg:grid-cols-3">
          {products.map((product, index) => (
            <Link key={product.title} to={`/products?category=${categoryIds[index]}`} className="h-full">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-border bg-card shadow-lg hover-lift gradient-slide dark:bg-steel-dark/70"
              >
                <div className="relative p-6 z-10">
                  <div className="flex items-center justify-between mb-4">
                    <product.icon className="w-8 h-8 text-steel dark:text-slate-300 group-hover:text-white transition-colors duration-300" />
                    <div className="relative">
                      <img
                        src="/images/coil-icon.png"
                        alt="Coil"
                        width={48}
                        height={48}
                        className="w-12 h-12 opacity-60 coil-spin group-hover:opacity-100"
                        style={{ borderRadius: "25px" }}
                      />
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-steel-dark dark:text-white group-hover:text-white mb-3 transition-colors duration-300">
                    {product.title}
                  </h3>

                  <p className="min-h-[3.5rem] text-steel dark:text-slate-300 group-hover:text-white/90 leading-relaxed transition-colors duration-300">
                    {product.description}
                  </p>
                </div>

                {/* Shimmer Effect */}
                <div className="absolute inset-0 shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
